import { startOfDay, isSameDay, addMinutes, endOfDay, areIntervalsOverlapping, differenceInMinutes, setHours, isBefore, addHours, } from "date-fns";
import { uid } from "./helpers";
import { roundTimeByStep } from "./time";
export function normalizeEvent(event, calendars, timeStep) {
    const normalized = {
        readonly: false,
        dragMove: true,
        dragResize: true,
        id: event.id || uid(),
        ...event,
    };
    let type;
    if (normalized.type) {
        type = calendars.find(t => t.id === normalized.type);
    }
    normalized.type = type ? type.id : calendars[0].id;
    const start_date = roundTimeByStep(normalized.start_date, timeStep);
    normalized.start_date = start_date;
    let end_date = roundTimeByStep(normalized.end_date, timeStep);
    if (start_date.valueOf() === end_date.valueOf()) {
        end_date = addMinutes(start_date, timeStep);
    }
    normalized.end_date = isBefore(end_date, start_date)
        ? addHours(start_date, 2)
        : end_date;
    return normalized;
}
export function sortEvents(data) {
    return data.sort((a, b) => a.start_date.valueOf() - b.start_date.valueOf());
}
export function isMultiEvent(event) {
    const { start_date, end_date, allDay } = event;
    const delta = differenceInMinutes(end_date, start_date); // 23.59
    return delta >= 1439 || allDay || !isSameDay(start_date, end_date);
}
export function isEventInTimeRange(event, range) {
    const { start_date, end_date } = event;
    const start = setHours(start_date, range[0]);
    const end = setHours(start_date, range[1]);
    return areIntervalsOverlapping({ start: start_date, end: end_date }, { start, end });
}
export function isEventInDay(event, range) {
    const { start_date, end_date } = event;
    const [start, end] = range;
    return areIntervalsOverlapping({ start: start_date, end: end_date }, { start, end });
}
export function stackEvents(data) {
    let index = 0;
    let events = sortEvents(data);
    const result = {};
    while (events.length) {
        const IDs = [];
        let last = events[0];
        IDs.push(last.id);
        events.forEach(event => {
            if (event.start_date >= last.end_date) {
                IDs.push(event.id);
                last = event;
            }
        });
        events = events.filter(ev => !IDs.includes(ev.id));
        IDs.forEach(id => (result[id] = index));
        index++;
    }
    return result;
}
export function roundEvents(events) {
    return sortEvents(events).map(event => {
        const ev = { ...event };
        ev.start_date = startOfDay(ev.start_date);
        ev.end_date = isSameDay(ev.end_date, addMinutes(ev.end_date, -1))
            ? ev.end_date
            : endOfDay(new Date(addMinutes(ev.end_date, -1)));
        return ev;
    });
}
export function getEventStyles(node, config) {
    function setStyles(config) {
        const target = node;
        const { style } = target;
        const { event, calendars, backgroundFactor } = config;
        const { eventData, position = {
            top: 0,
            width: "100%",
            left: 0,
            height: "32px",
            zIndex: 0,
        }, } = event;
        const { top, left, width, height } = position;
        const type = calendars.find(calendar => calendar.id === eventData.type) ||
            calendars[0];
        const background = eventData.color?.[backgroundFactor] ||
            type.color[backgroundFactor];
        style.setProperty("--wx-border-color", eventData.color?.border || type.color.border);
        const color = eventData.color?.textColor || type.color.textColor;
        style.top = top;
        style.left = left;
        style.width = width;
        style.height = height;
        if (color) {
            style.color = color;
        }
        if (background) {
            style.setProperty("--wx-background", background);
        }
        style.zIndex = position.zIndex || 0;
        const { offsetHeight } = target;
        let lineHeight;
        let paddingLeft;
        ({ lineHeight, paddingLeft } = window.getComputedStyle(target)); // Padding from DayEvent .event-box ( paddingTop === paddingLeft)
        lineHeight = parseInt(lineHeight);
        paddingLeft = parseInt(paddingLeft);
        if (!lineHeight)
            return;
        if (offsetHeight <= lineHeight + paddingLeft &&
            !target.classList.contains("wx-event-calendar-event-box--small")) {
            target.classList.add("wx-event-calendar-event-box--small");
        }
        if (offsetHeight > lineHeight + paddingLeft) {
            style.fontSize = "var(--wx-font-size)";
            if (target.classList.contains("wx-event-calendar-event-box--small")) {
                target.classList.remove("wx-event-calendar-event-box--small");
            }
        }
        if (offsetHeight <= lineHeight) {
            style.lineHeight = style.minHeight;
            style.fontSize = "var(--wx-font-size-sm)";
        }
    }
    setStyles(config);
    return {
        update: (nextConfig) => setStyles(nextConfig),
    };
}
//# sourceMappingURL=events.js.map